// extracted by mini-css-extract-plugin
module.exports = {"stock":"Stock_stock__3lJ12"};